<!-- FOB Charges Listing -->
<div class="card">
  <!-- Card Header -->
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <h3 class="fw-bold m-0">FOB Charges Management</h3>
    </div>
    <div class="card-toolbar">
      <!-- Base Toolbar -->
      <div class="d-flex justify-content-end" data-kt-fob-charge-table-toolbar="base">
        <!-- Search -->
        <div class="d-flex align-items-center position-relative my-1 me-3">
          <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <input
            type="text"
            [(ngModel)]="searchTerm"
            (keyup.enter)="loadFobCharges(1, searchTerm, filters)"
            class="form-control form-control-sm form-control-solid w-250px ps-13"
            placeholder="Search FOB Charges">
        </div>

        <!-- Add Button -->
        <button
          type="button"
          class="btn btn-sm btn-primary"
          (click)="openAddFobChargeModal()">
          <i class="ki-duotone ki-plus fs-2"></i>
          Add FOB Charge
        </button>
      </div>

      <!-- Selected Toolbar -->
      <div class="d-flex justify-content-end align-items-center d-none" data-kt-fob-charge-table-toolbar="selected">
        <div class="fw-bold me-5">
          <span class="me-2">{{ selectedFobCharges.length }}</span> Selected
        </div>
        <button
          type="button"
          class="btn btn-sm btn-danger"
          (click)="deleteSelectedFobCharges()">
          Delete Selected
        </button>
      </div>
    </div>
  </div>

  <!-- Card Body -->
  <div class="card-body py-4">
    <!-- Loading State -->
    <div *ngIf="isLoading" class="text-center py-10">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="!isLoading && fobCharges.length === 0" class="text-center py-10">
      <div class="mb-5">
        <i class="ki-duotone ki-file-deleted fs-5x text-muted">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
      </div>
      <h3 class="text-muted">No FOB charges found</h3>
      <p class="text-muted">Start by adding a new FOB charge</p>
    </div>

    <!-- Data Table -->
    <div *ngIf="!isLoading && fobCharges.length > 0" class="table-responsive">
      <table class="table align-middle table-row-dashed fs-6 gy-5" id="kt_fob_charges_table">
        <thead>
          <tr class="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
            <th class="w-25px text-center">
              <div class="form-check form-check-sm form-check-custom form-check-solid">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [checked]="isAllSelected()"
                  [indeterminate]="isIndeterminate()"
                  (change)="toggleAllSelection($event)">
              </div>
            </th>
            <th class="min-w-125px">Name</th>
            <th class="min-w-100px">Charge</th>
            <th class="text-end min-w-100px">Actions</th>
          </tr>
        </thead>
        <tbody class="text-gray-600 fw-semibold">
          <tr *ngFor="let fobCharge of fobCharges; trackBy: trackByFn">
            <td class="text-center pe-0">
              <div class="form-check form-check-sm form-check-custom form-check-solid">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [value]="fobCharge._id"
                  [checked]="isSelected(fobCharge._id)"
                  (change)="toggleSelection(fobCharge._id, $event)">
              </div>
            </td>
            <td class="ps-2">
              <div class="d-flex align-items-center">
                <div class="d-flex justify-content-start flex-column">
                  <span class="text-dark fw-bold text-hover-primary fs-6">{{ fobCharge.name || 'N/A' }}</span>
                </div>
              </div>
            </td>
            <td>
              <span class="text-dark fw-semibold">{{ fobCharge.charge || 0 | currency:'JPY':'symbol':'1.0-0' }}</span>
            </td>
            <td class="text-end">
              <div class="d-flex justify-content-end gap-2">
                <!-- Edit Icon -->
                <button
                  type="button"
                  class="btn btn-sm btn-icon btn-light-primary"
                  (click)="openEditModal(fobCharge)"
                  title="Edit FOB Charge">
                  <i class="ki-duotone ki-pencil fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </button>

                <!-- Delete Icon -->
                <button
                  type="button"
                  class="btn btn-sm btn-icon btn-light-danger"
                  (click)="deleteFobCharge(fobCharge)"
                  title="Delete FOB Charge">
                  <i class="ki-duotone ki-trash fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                    <span class="path4"></span>
                    <span class="path5"></span>
                  </i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div *ngIf="!isLoading && fobCharges.length > 0">
      <app-pagination
        [paginationInfo]="paginationInfo"
        [loading]="isLoading"
        (pageChange)="onPageChange($event)">
      </app-pagination>
    </div>
  </div>
</div>

<!-- FOB Charge Add/Edit Modal -->
<app-add-edit-md-fob-charges
  (fobChargeAdded)="onFobChargeAdded()"
  (fobChargeUpdated)="onFobChargeUpdated()">
</app-add-edit-md-fob-charges>
